var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 20 19",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.0250015 9.69088c0-5.48398 4.3957685-9.69088 9.9562185-9.69088 5.48528 0 9.99378 4.2069 9.99378 9.69088 0 4.17762-2.5809 7.60272-6.2293 9.02252-.3826.1489-.8008-.0701-.9276-.4605l-.9934-3.0581c-.1263-.389.086-.8021.4463-.9957 1.5248-.8194 2.5193-2.4642 2.5193-4.47065 0-2.92981-2.0664-5.10838-4.80908-5.10838-2.81779 0-4.80904 2.17857-4.80904 5.10838 0 2.07905 1.00274 3.74205 2.592 4.53245.37606.187.60323.6096.47355 1.009l-.98883 3.0456c-.12535.386-.53622.6055-.91682.4642-3.7099-1.3772-6.3070785-4.8446-6.3070785-9.08882z",
    fill: "#17a680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d938cf33efe770dffa4da99352bbcc8.svg";
export { ForwardRef as ReactComponent };